export default __webpack_public_path__ + "static/media/kotlin-svgrepo-com.288d3246.svg";